import { createSlice } from "@reduxjs/toolkit";
import { reflowPageSections } from "./util";

const initialPageState = () => {
    return {
        type: "",
        pageHeading: "",
        headingVisible: true,
        description: "",
        path: "",
        sections: [],
        defaultHeadlineImage: "",
        bannerImage: "",
        initialTotalCards: {},
        hasNativeAd: true,
        lineupSwaps: {},
        adTestGroup: null,
    };
};
/**
 * Reducer for Page action creators
 * @param {object} state
 * @param {object} action
 * @returns {object} merged state
 */
const pageSlice = createSlice({
    name: "page",
    initialState: initialPageState(),
    reducers: {
        page_initial_data: (state, action) => {
            if (action.payload && !action.payload.hasOwnProperty("page")) {
                return state;
            }

            return {
                ...state,
                type: "landing",
                pageHeading: action.payload.page.pageHeading,
                headingVisible: action.payload.page.headingVisible,
                description: action.payload.page.description,
                path: action.payload.page.path,
                sections: reflowPageSections(action.payload.page.sections),
                defaultHeadlineImage: action.payload.page.defaultHeadlineImage,
                bannerImage: action.payload.page.bannerImage,
                initialTotalCards: action.payload.page.initialTotalCards,
                lineupSwaps: {
                    ...state.lineupSwaps,
                    ...action.payload.lineupSwapObject,
                },
                timezoneText: action.payload.page.timezoneText,
            };
        },

        page_update_sections: (state, action) => {
            return {
                ...state,
                ...action.payload,
                sections: reflowPageSections(action.payload.sections),
            };
        },

        page_update_native_ad: (state, action) => {
            return {
                ...state,
                ...action.payload,
                sections: reflowPageSections(action.payload.sections),
            };
        },

        reset_page: (state) => {
            return {
                ...initialPageState(),
                lineupSwaps: { ...state.lineupSwaps },
            };
        },

        page_update_ad_test: (state, action) => {
            return {
                ...state,
                adTestGroup: action.payload,
            };
        },
    },
});

export const {
    page_initial_data,
    page_update_sections,
    page_update_native_ad,
    reset_page,
    page_update_ad_test,
} = pageSlice.actions;

export default pageSlice.reducer;
